import { FC } from 'react';

import { Button } from 'components/parts/Button';
import { PlainDialog } from 'components/parts/PlainDialog';
import CloseIcon from 'images/icon/close_white.svg';
import PinchInIcon from 'images/icon/pinch-in.svg';

import styles from './MapDialogView.module.scss';

type MapDialogViewProps = {
  isOpen: boolean;
  handleClose: () => void;
  getClueMapFileName: () => string;
};

export const MapDialogView: FC<MapDialogViewProps> = ({
  isOpen,
  handleClose,
  getClueMapFileName,
}) => {
  return (
    <PlainDialog isOpen={isOpen}>
      <div className={styles.dialogHead}>
        <button
          type="button"
          className={styles.dialogCloseIconButton}
          onClick={() => {
            handleClose();
          }}
        >
          <img src={CloseIcon} alt="閉じる" className={styles.dialogCloseIcon} />
        </button>
      </div>
      <div className={styles.dialogBody}>
        <div className={styles.dialogImageWrap}>
          <img
            src={
              getClueMapFileName() &&
              require(`components/pages/Area/images/${getClueMapFileName()}`)
            }
            alt=""
            className={styles.dialogImage}
          />
        </div>
        <p className={styles.dialogExplanation}>
          <img src={PinchInIcon} alt="" className={styles.dialogExplanationIcon} />
          <span className={styles.dialogExplanationText}>二本指で拡大ができます</span>
        </p>
      </div>
      <div className={styles.dialogFoot}>
        <Button text="閉じる" styleType="secondary" handleClick={handleClose}></Button>
      </div>
    </PlainDialog>
  );
};
